import { Box, Skeleton } from "@mui/material";
import styles from "./ViewFaq.module.scss";

const ViewFaqSkeleton = () => (
  <Box className={styles.container}>
    {/* Header Skeleton */}
    <Box className={styles.headingContainer}>
      <Skeleton variant="text" width={700} height={20} />
    </Box>

    {/* Title Skeleton */}
    <Skeleton variant="text" width="60%" height={32} sx={{ mt: 2 }} />

    {/* Body Skeleton */}
    <Box className={styles.articleScrollWrapper} sx={{ mt: 1 }}>
      {[...Array(6)].map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          width="100%"
          height={16}
          sx={{ mb: 5, borderRadius: 1 }}
        />
      ))}
    </Box>
  </Box>
);

export default ViewFaqSkeleton;
